module.exports = __webpack_public_path__ + "img/ic_32_gender_man.c17e9481.svg";